export const lang = {
    test_data:'i18n 国际化',
    login: '密码登录',
    register: '注册账号',
    remember: '记住密码',
    logout:'注销',
    home: '首页',
    about: '关于',
    aboutDesc: '这是关于页面',
    forget: '忘记密码',
    submit: '提交',
    username: '账号',
    password: '密码',
}
